import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { Search, X, ArrowDownWideNarrow, ArrowUpWideNarrow } from "lucide-react";

/**
 * Search + Katedra/Status/Date-range filters + sort toggle for Secretariat lists.
 * Controlled by parent — emits onChange callbacks.
 */
export function SecretariatFilters({
  allKatedras,
  search, onSearchChange,
  filterKatedra, onKatedraChange,
  filterStatus, onStatusChange,
  filterFrom, onFromChange,
  filterTo, onToChange,
  sortDir, onSortToggle,
  hasFilters, onClear,
}) {
  return (
    <Card>
      <CardContent className="p-4 flex flex-wrap items-center gap-3">
        <div className="relative flex-1 min-w-[220px]">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input
            type="text"
            placeholder="Pretraži po imenu, e-mailu, katedri, klasa/urbroj…"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-9"
            data-testid="sec-search"
          />
        </div>
        <Select value={filterKatedra} onValueChange={onKatedraChange}>
          <SelectTrigger className="w-[260px]" data-testid="sec-filter-katedra">
            <SelectValue placeholder="Sve katedre"/>
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Sve katedre</SelectItem>
            {allKatedras.map(k => <SelectItem key={k} value={k}>{k}</SelectItem>)}
          </SelectContent>
        </Select>
        <Select value={filterStatus} onValueChange={onStatusChange}>
          <SelectTrigger className="w-[180px]" data-testid="sec-filter-status">
            <SelectValue placeholder="Svi statusi"/>
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Svi statusi</SelectItem>
            <SelectItem value="approved">Suglasan od voditelja</SelectItem>
            <SelectItem value="decided">U izradi rješenja</SelectItem>
            <SelectItem value="sent">Rješenje izrađeno</SelectItem>
            <SelectItem value="rejected">Odbijeno</SelectItem>
          </SelectContent>
        </Select>
        <div className="flex items-center gap-1">
          <Input type="date" value={filterFrom} onChange={(e) => onFromChange(e.target.value)}
            className="w-[150px]" data-testid="sec-filter-from" placeholder="Od"/>
          <span className="text-xs text-muted-foreground">–</span>
          <Input type="date" value={filterTo} onChange={(e) => onToChange(e.target.value)}
            className="w-[150px]" data-testid="sec-filter-to" placeholder="Do"/>
        </div>
        {hasFilters && (
          <Button variant="ghost" size="sm" onClick={onClear} data-testid="sec-clear-filters">
            <X className="w-4 h-4 mr-1"/>Očisti filtere
          </Button>
        )}
        <Button variant="outline" size="sm" onClick={onSortToggle} data-testid="sec-sort-toggle"
          title={`Sortirano: ${sortDir === "desc" ? "najnoviji prvo" : "najstariji prvo"}`}>
          {sortDir === "desc"
            ? <><ArrowDownWideNarrow className="w-4 h-4 mr-1.5"/> Najnoviji</>
            : <><ArrowUpWideNarrow className="w-4 h-4 mr-1.5"/> Najstariji</>}
        </Button>
      </CardContent>
    </Card>
  );
}
